'use strict';

export {};

$(function () {
   $(document)
       .on('click', '.input-box .form-label', function (e) {
           e.preventDefault();
           e.stopPropagation();
           $(this).siblings('.input-text').trigger('focus');
       })
       .on('click', '.input-password-wrap .show-password', function () {
            const $self = $(this);

            if ($self.hasClass('is-shown')) {
                $self.parent().find('.input-text').attr('type', 'password');
                $self.text($self.data('show'));
            } else {
                $self.parent().find('.input-text').attr('type', 'text');
                $self.text($self.data('hide'));
            }

            $self.toggleClass('is-shown');
        })
        .on('input change', '.input-box .input-text__search.input-text__search--with-reset', updateSearchInputResetButtonState)
        .on('click', '.input-box .symbol__search-reset, .input-box .symbol__search-reset-lg', function () {
            $(this)
                .siblings('.input-text__search')
                .val('')
                .trigger('input')
                .trigger('change');
        });

    // применить выставление сосотяний к полям поиска
    $('.input-text__search.input-text__search--with-reset').each(updateSearchInputResetButtonState);

    // в зависисмости от состояния поля поиска обновляет состояние кнопки сброса
    function updateSearchInputResetButtonState() {
        let value = $(this).val().trim() || '',
            $resetButton = $(this).siblings('.symbol__search-reset, .symbol__search-reset-lg');

        if (value.length > 0) {
            $resetButton.show();
        } else {
            $resetButton.hide();
        }
    }
});


// WEBPACK FOOTER //
// ./js/main/module/input-box.js